import { render, staticRenderFns } from "./PerformanceRightChart.vue?vue&type=template&id=3c571697&scoped=true"
import script from "./PerformanceRightChart.vue?vue&type=script&lang=js"
export * from "./PerformanceRightChart.vue?vue&type=script&lang=js"
import style0 from "./PerformanceRightChart.vue?vue&type=style&index=0&id=3c571697&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c571697",
  null
  
)

export default component.exports